<!-- 侧边栏 -->
<template>
  <transition name="side-transition">
    <div
      class="side"
      :class="deviceType()"
      v-if="(getSystem() !== 'iOS' && getSystem() !== 'android') || props.scroll > 800"
    >
      <!-- 展开按钮 -->
      <div
        class="btn expand"
        :class="[XhLang, deviceType(), activityEnd? 'activityEnd':'']"
        @click="showSide"
        v-if="sideContent "
      ></div>
      <!-- 收起按钮 -->
      <div
        class="btn away"
        @click="showSide"
        v-if="!sideContent"
      ></div>
      <div
        class="content"
        :class="[XhLang, activityEnd ? 'activityEnd':'']"
        v-if="!sideContent"
      >
        <!-- 关注FB抽奖 -->
        <div
          class="like"
          :class="XhLang"
          v-if="deviceType() == 'wap'"
        >
          <a
            :href="store.state.articlesData['fbPage' + XhLang.toUpperCase()]"
            :class="'market_FBdraw_right'"
            target="_blank"
          >
          </a>
        </div>
        <!-- 预约好礼 -->
        <div
          class="reserve"
          :class="XhLang"
          v-if="(deviceType() == 'pc' && !activityEnd)"
        >
          <router-link
            class="market_phone_right"
            to="/pre"
          >
          </router-link>
        </div>
        <!-- 特惠储值 -->
        <div
          class="pay"
          :class="XhLang"
          v-if="(deviceType() == 'pc' && activityEnd)"
        >
          <a
            :href="store.state.articlesData.payUrl"
            class="market_pay_above"
            target="_blank"
          ></a>
        </div>
        <down-info
          :position="'gwSideInfo'"
          :apkCounts="'market_above_apk'"
          :huaweiCounts="'market_above_huawei'"
          :androidCounts="'market_right_gp'"
          :iosCounts="'market_right_ios'"
          :FBCounts="'market_right_FB'"
        ></down-info>
        <div
          class="qrcode"
          v-if="deviceType() == 'pc'"
        >
          <img
            :src="store.state.articlesData.gwQRcode"
            v-bind:key="index"
          >
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { defineProps, ref, watch } from "vue";
const props = defineProps(["scroll", "activityEnd"]);

import { getSystem, deviceType } from "@/util/base";

import downInfo from "@/components/down.vue";

import { useStore } from "vuex";
const store = useStore();

// 语言
import { useI18n } from "vue-i18n";
const { locale } = useI18n();
const XhLang = locale.value;

const sideContent = ref(true);
const showSide = () => {
  sideContent.value = !sideContent.value;
  state.value = true;
};

const state = ref(false);
const activityEnd = ref(props.activityEnd);

const scrollToTop = () => {
  const scrollTops =
    document.documentElement.scrollHeight / document.documentElement.scrollTop;
  if (
    (getSystem() == "PC" && scrollTops < 5) ||
    (getSystem() !== "PC" && props.scroll > 800)
  ) {
    if (!state.value) {
      sideContent.value = false;
    }
  } else {
    if (!state.value) {
      sideContent.value = true;
    }
  }
};
window.addEventListener("scroll", scrollToTop);

watch(
  () => props.activityEnd,
  (newVal) => {
    if (newVal) {
      activityEnd.value = newVal;
    }
  },
  { immediate: true }
);
</script>

<style lang=scss scoped>
.pc {
  top: 15% !important;
}
.side {
  position: fixed;
  right: 0;
  top: 10%;
  z-index: 1000;
  display: flex;
  color: RED;
  .finish {
    display: none;
  }
  .expand {
    width: 1.49rem;
    height: 2.33rem;
    &.wap {
      width: 0.9rem;
    }
    &.cn {
      background: url("../../../assets/images/cn/expand.png") no-repeat;
      background-size: 100% auto;
    }
    &.activityEnd.cn {
      background: url("../../../assets/images/cn/down-expand.png") no-repeat;
      background-size: 100% auto;
    }
    &.en {
      background: url("../../../assets/images/en/expand.png") no-repeat;
      background-size: 100% auto;
    }
    &.activityEnd.en {
      background: url("../../../assets/images/en/down-expand.png") no-repeat;
      background-size: 100% auto;
    }
    &.th {
      background: url("../../../assets/images/th/expand.png") no-repeat;
      background-size: 100% auto;
    }
    &.activityEnd.th {
      background: url("../../../assets/images/th/down-expand.png") no-repeat;
      background-size: 100% auto;
    }
    margin: 1rem 0.15rem;
    cursor: pointer;
  }
  .away {
    width: 0.47rem;
    height: 0.47rem;
    background: url("../../../assets/images/put_away.png") no-repeat;
    background-size: 100% auto;
    margin: 1rem 0;
    cursor: pointer;
  }
  .content {
    width: 2.56rem;
    height: 8rem;
    &.cn {
      background: url("../../../assets/images/cn/side.png") no-repeat;
      background-size: 100% auto;
    }
    &.activityEnd.cn {
      background: url("../../../assets/images/cn/down-side.png") no-repeat;
      background-size: 100% auto;
    }
    &.en {
      background: url("../../../assets/images/en/side.png") no-repeat;
      background-size: 100% auto;
    }
    &.activityEnd.en {
      background: url("../../../assets/images/en/down-side.png") no-repeat;
      background-size: 100% auto;
    }
    &.th {
      background: url("../../../assets/images/th/side.png") no-repeat;
      background-size: 100% auto;
    }
    &.activityEnd.th {
      background: url("../../../assets/images/th/down-side.png") no-repeat;
      background-size: 100% auto;
    }
    display: flex;
    flex-direction: column;
    align-items: center;

    .reserve {
      width: 2.01rem;
      height: 0.6rem;
      margin: 3.5rem 0 0 0;
      a {
        display: block;
        width: 2.01rem;
        height: 0.6rem;
      }
      &.cn {
        background: url("../../../assets/images/gift-cn.png") no-repeat;
        background-size: 100% auto;
      }
      &.en {
        background: url("../../../assets/images/gift-en.png") no-repeat;
        background-size: 100% auto;
      }
      &.th {
        background: url("../../../assets/images/gift-th.png") no-repeat;
        background-size: 100% auto;
      }
    }

    .pay {
      width: 2.01rem;
      height: 0.6rem;
      margin: 3.5rem 0 0 0;
      a {
        display: block;
        width: 2.01rem;
        height: 0.6rem;
      }
      &.cn {
        background: url("../../../assets/images/pay-cn.png") no-repeat;
        background-size: 100% auto;
      }
      &.en {
        background: url("../../../assets/images/pay-en.png") no-repeat;
        background-size: 100% auto;
      }
      &.th {
        background: url("../../../assets/images/pay-th.png") no-repeat;
        background-size: 100% auto;
      }
    }
    .like {
      width: 2.01rem;
      height: 0.55rem;
      &.cn {
        background: url("../../../assets/images/cn/like.png") no-repeat;
        background-size: 100% auto;
      }
      &.en {
        background: url("../../../assets/images/en/like.png") no-repeat;
        background-size: 100% auto;
      }
      &.th {
        background: url("../../../assets/images/th/like.png") no-repeat;
        background-size: 100% auto;
      }
      margin: 3.5rem 0 0.05rem;
      a {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    .qrcode {
      width: 1.76rem;
      height: 1.76rem;
      background: #fff;
      margin: 0.2rem 0 0;
      img {
        width: 100%;
      }
    }
  }
}
.side.wap {
  z-index: 999;
  .expand {
    &.cn {
      background: url("../../../assets/images/cn/expand-wap.png") no-repeat;
      background-size: 100% auto;
    }
    &.activityEnd.cn {
      background: url("../../../assets/images/cn/down-expand-wap.png") no-repeat;
      background-size: 100% auto;
    }
    &.en {
      background: url("../../../assets/images/en/expand-wap.png") no-repeat;
      background-size: 100% auto;
    }
    &.activityEnd.en {
      background: url("../../../assets/images/en/down-expand-wap.png") no-repeat;
      background-size: 100% auto;
    }
    &.th {
      background: url("../../../assets/images/th/expand-wap.png") no-repeat;
      background-size: 100% auto;
    }
    &.activityEnd.th {
      background: url("../../../assets/images/th/down-expand-wap.png") no-repeat;
      background-size: 100% auto;
    }
  }
  .content {
    width: 2.24rem;
    height: 4.24rem;
    &.cn {
      background: url("../../../assets/images/cn/side-wap.png") no-repeat;
      background-size: 100% auto;
    }
    &.activityEnd.cn {
      background: url("../../../assets/images/cn/down-side-wap.png") no-repeat;
      background-size: 100% auto;
    }
    &.en {
      background: url("../../../assets/images/en/side-wap.png") no-repeat;
      background-size: 100% auto;
    }
    &.activityEnd.en {
      background: url("../../../assets/images/en/down-side-wap.png") no-repeat;
      background-size: 100% auto;
    }
    &.th {
      background: url("../../../assets/images/th/side-wap.png") no-repeat;
      background-size: 100% auto;
    }
    &.activityEnd.th {
      background: url("../../../assets/images/th/down-side-wap.png") no-repeat;
      background-size: 100% auto;
    }

    .reserve {
      width: 1.7rem;
      height: 0.55rem;
      margin: 2.6rem 0 0 0;
      &.cn {
        background: url("../../../assets/images/gift-cn.png") no-repeat;
        background-size: 100% auto;
      }
      &.en {
        background: url("../../../assets/images/gift-en.png") no-repeat;
        background-size: 100% auto;
      }
      &.th {
        background: url("../../../assets/images/gift-th.png") no-repeat;
        background-size: 100% auto;
      }
    }

    .pay {
      width: 1.7rem;
      height: 0.55rem;
      margin: 2.6rem 0 0 0;
      &.cn {
        background: url("../../../assets/images/pay-cn.png") no-repeat;
        background-size: 100% auto;
      }
      &.en {
        background: url("../../../assets/images/pay-en.png") no-repeat;
        background-size: 100% auto;
      }
      &.th {
        background: url("../../../assets/images/pay-th.png") no-repeat;
        background-size: 100% auto;
      }
    }
    .like {
      width: 1.7rem;
      height: 0.6rem;
      &.cn {
        background: url("../../../assets/images/cn/like-wap.png") no-repeat;
        background-size: 100% auto;
      }
      &.en {
        background: url("../../../assets/images/en/like-wap.png") no-repeat;
        background-size: 100% auto;
      }
      &.th {
        background: url("../../../assets/images/th/like-wap.png") no-repeat;
        background-size: 100% auto;
      }
      margin: 2.5rem 0 0 0;
    }
  }
}
</style>
